import { IqChatFrom, IqChatMessage } from '../../models/iq-boost';

export const CHAT_REPLY_MOCK: IqChatMessage[] = [
  {
    from: IqChatFrom.Ai,
    content:
      'Based on the recent timeline, the last meaningful interaction was a call on April 14th where the contact mentioned reviewing their portfolio allocation. There are no open opportunities logged currently.',
  },
  {
    from: IqChatFrom.User,
    content: 'What follow-up actions were agreed on during that call?',
  },
  {
    from: IqChatFrom.Ai,
    content:
      'The call notes indicate two agreed actions: (1) send a comparative fund performance report by end of April, and (2) schedule a review meeting for Q3. Neither action has been logged as completed in the CRM.',
  },
  {
    from: IqChatFrom.User,
    content: 'Has the contact been in touch since April?',
  },
  {
    from: IqChatFrom.Ai,
    content:
      'No outbound or inbound interactions have been recorded since April 14th. The contact has not replied to the last email sent on April 18th.',
  },
];
